import React from "react";

interface HeroProps {
  onBookingClick: () => void;
}

export default function Hero({ onBookingClick }: HeroProps) {
  const topRowImages = [
    "https://imagedelivery.net/RAP5LnVUMDfmG3LRL4kHtw/f1ece7f7-c8ab-496c-7d8d-be83a671d201/640?exp=1770681600&sig=9070fc27bc1eb94a7f7bb44dd84d3186ae1a1a55fc55e0dc18365f57a233383e",
    "https://imagedelivery.net/RAP5LnVUMDfmG3LRL4kHtw/cd711d24-b006-4867-ef75-83866046ec01/640?exp=1770681600&sig=4c91700094e0ccc8c5068aa1b4b954d8985454e2256e2edda9a20fc4d215abb8",
    "https://imagedelivery.net/RAP5LnVUMDfmG3LRL4kHtw/9b63fe0b-f19d-4bb4-4ea3-d0850445a201/640?exp=1770681600&sig=4ee7278d9e120df6c983e91e9e4da6eb925c4910ca939bfd05b7b9cfd290f3ee",
    "https://imagedelivery.net/RAP5LnVUMDfmG3LRL4kHtw/5e3714cb-4cb7-4b4e-66bf-bf90679dc501/640?exp=1770681600&sig=6e5783e684bcf0e38e834233279a843b70284f8e3e45de225fae63fdd01d7844",
    "https://imagedelivery.net/RAP5LnVUMDfmG3LRL4kHtw/6a3f675a-ead1-457c-4ef3-6e38b75af401/640?exp=1770681600&sig=7d0057941e29a46ab9cb8f9567610f37acf414fa9b426303b789db773b08412b",
  ];

  const bottomRowImages = [
    "https://imagedelivery.net/RAP5LnVUMDfmG3LRL4kHtw/ec23230e-ed0f-466c-bad6-3dba93826501/640?exp=1770681600&sig=e14b70b7dd9d391a778cef99fa7a465c9f0324141fc8417f9b9b679fa8398184",
    "https://imagedelivery.net/RAP5LnVUMDfmG3LRL4kHtw/443ffe0e-141e-4e7e-9960-3fa7b5396101/640?exp=1770681600&sig=acea3b29f53302c364034f53b4b1ce5249460c4a62a3797d74c26bf379c97cb1",
    "https://imagedelivery.net/RAP5LnVUMDfmG3LRL4kHtw/5e3714cb-4cb7-4b4e-66bf-bf90679dc501/640?exp=1770681600&sig=6e5783e684bcf0e38e834233279a843b70284f8e3e45de225fae63fdd01d7844",
    "https://imagedelivery.net/RAP5LnVUMDfmG3LRL4kHtw/6a3f675a-ead1-457c-4ef3-6e38b75af401/640?exp=1770681600&sig=7d0057941e29a46ab9cb8f9567610f37acf414fa9b426303b789db773b08412b",
  ];

  return (
    <section className="relative pt-32 pb-20 px-6 lg:px-12 bg-[#042A60] overflow-hidden">
      <div className="max-w-4xl mx-auto text-center mb-16">
        <h1 className="text-4xl lg:text-6xl text-white mb-6 leading-tight font-light">
          KI, die mitarbeitet – nicht überfordert
        </h1>
        <p className="text-base lg:text-lg text-white/90 mb-8 leading-relaxed max-w-3xl mx-auto">
          klar:ki übersetzt künstliche Intelligenz in verständliche Assistent:innen, die deinen
          Arbeitsalltag leichter und dein Geschäft nachhaltig erfolgreicher machen. Konkrete KI-
          Assistent:innen statt Tool-Chaos. Messbare Effizienz und Wachstum statt Experimente.
          Menschliche Intelligenz bleibt im Mittelpunkt – KI unterstützt, ersetzt nicht.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={onBookingClick}
            className="px-8 py-3 bg-[#0A6AF0] text-white text-base font-normal hover:bg-[#0858c7] transition-colors cursor-pointer whitespace-nowrap"
          >
            Klarheitsgespräch buchen
          </button>
        </div>
      </div>

      {/* Statische Bildergalerie - 1 Reihe */}
      <div className="max-w-6xl mx-auto">
        {/* Obere Reihe - links angeschnitten */}
        <div className="flex gap-4 mb-4 -ml-16">
          {topRowImages.map((img, index) => (
            <div
              key={index}
              className={`flex-shrink-0 overflow-hidden ${
                index === 0 ? "w-48 lg:w-56" : "w-56 lg:w-64"
              } h-40 lg:h-48`}
            >
              <img
                src={img}
                alt={`Team member ${index + 1}`}
                className="w-full h-full object-cover object-top"
              />
            </div>
          ))}
        </div>
        {/* Optional: you can add the bottom row here if needed */}
      </div>
    </section>
  );
}